
import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import WakeUpLoader from './components/WakeUpLoader';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'sonner';
import AuthPage from './pages/AuthPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPage from './pages/PrivacyPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TooltipProvider } from './components/ui/tooltip';
import StudioLayout from './components/StudioLayout';
import StudioDashboard from './pages/StudioDashboard';
import StudioProjectEditor from './pages/StudioProjectEditor';
import TechniquesLibrary from './pages/TechniquesLibrary';
import TechniqueWorkspace from './pages/TechniqueWorkspace';
import SDLCReference from './pages/SDLCReference';
import GeniusLabsPage from './pages/GeniusLabsPage';
import BAStudioGuide from './pages/BAStudioGuide';
import BAIntroPage from './pages/BAIntroPage';
import MyActivityPage from './pages/MyActivityPage';
import SecurityPage from './pages/SecurityPage';
import PMSimGame from './pages/PMSimGame';
import RegistrationSimGame from './pages/RegistrationSimGame';
import PortfolioGate from './components/PortfolioGate';

const queryClient = new QueryClient();


function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <WakeUpLoader />;

  return user ? children : <Navigate to="/" />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <WakeUpLoader />;

  return user ? <Navigate to="/studio" /> : children;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <TooltipProvider>
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <AuthPage />
              </PublicRoute>
            }
          />
          
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/business-analysis" element={<PrivateRoute><BAIntroPage /></PrivateRoute>} />

          <Route path="/studio/*" element={<PrivateRoute><StudioLayout /></PrivateRoute>}>
            <Route index element={<StudioDashboard />} />
            <Route path="techniques" element={<TechniquesLibrary />} />
            <Route path="techniques/:id" element={<TechniqueWorkspace />} />
            <Route path="sdlc" element={<SDLCReference />} />
            <Route path="genius-labs" element={<GeniusLabsPage />} />
            <Route path="pm-game" element={<PMSimGame />} />
            <Route path="registration-sim" element={<RegistrationSimGame />} />
            <Route path="activity" element={<MyActivityPage />} />
            <Route path="security" element={<PortfolioGate><SecurityPage /></PortfolioGate>} />
            <Route path="guide" element={<BAStudioGuide />} />
          </Route>
          <Route path="/studio/project/:id" element={<PrivateRoute><StudioProjectEditor /></PrivateRoute>} />
        </Routes>
      </HashRouter>
      <Toaster position="top-right" />
    </AuthProvider>
    </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
